// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Skillet$LiteracyplanetTupperware from "../v2/Skillet.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as SkilfulClozeCommon$LiteracyplanetTupperware from "../v2/SkilfulClozeCommon.res.mjs";
import * as V3ClozeBucketProvider$LiteracyplanetTupperware from "./V3ClozeBucketProvider.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "./TupperwareLayoutSwitch.res.mjs";
import * as PilotClozeBucketProvider$LiteracyplanetTupperware from "./PilotClozeBucketProvider.res.mjs";

var overClassName = Skillet$LiteracyplanetTupperware.SkilfulClozeDropContainer.overClassName;

var dropClassName = Skillet$LiteracyplanetTupperware.SkilfulClozeDropContainer.className;

function SkilfulClozeBucketProvider$Skilful__$ResponseContainer(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulClozeDragTextContainer.ResponseContainer.className,
              onClick: props.onClick
            }, props.children);
}

var ResponseContainer = {
  make: SkilfulClozeBucketProvider$Skilful__$ResponseContainer
};

function SkilfulClozeBucketProvider$Skilful__$DragOverlayContainer(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulClozeDragOverlayContainer.className
            }, props.children);
}

var DragOverlayContainer = {
  make: SkilfulClozeBucketProvider$Skilful__$DragOverlayContainer
};

function SkilfulClozeBucketProvider$Skilful__$DroppedContainer(props) {
  return React.createElement("div", {
              className: Skillet$LiteracyplanetTupperware.SkilfulClozeDroppedContainer.className,
              onClick: props.onClick
            }, props.children);
}

var DroppedContainer = {
  make: SkilfulClozeBucketProvider$Skilful__$DroppedContainer
};

function SkilfulClozeBucketProvider$Skilful__$HiddenDrag(props) {
  var __marked = props.marked;
  var marked = __marked !== undefined ? __marked : false;
  return React.createElement("div", {
              style: {
                cursor: marked ? "default" : "pointer",
                opacity: "0.5",
                userSelect: "none"
              },
              onClick: props.onClick
            }, props.children);
}

var HiddenDrag = {
  make: SkilfulClozeBucketProvider$Skilful__$HiddenDrag
};

function renderDragOverlayComponent(children) {
  return React.createElement(SkilfulClozeBucketProvider$Skilful__$DragOverlayContainer, {
              children: children
            });
}

function renderAlreadyDraggedPlaceholder(onClick, children) {
  return React.createElement(SkilfulClozeBucketProvider$Skilful__$HiddenDrag, {
              onClick: onClick,
              children: children
            });
}

function renderAlreadyDraggedAndMarkedPlaceholder(onClick, children) {
  return React.createElement(SkilfulClozeBucketProvider$Skilful__$HiddenDrag, {
              marked: true,
              onClick: onClick,
              children: children
            });
}

function renderDroppedComponent(onClick, children) {
  return React.createElement(SkilfulClozeBucketProvider$Skilful__$DroppedContainer, {
              onClick: onClick,
              children: children
            });
}

function renderCorrectDroppedComponent(onClick, children) {
  return React.createElement(SkilfulClozeBucketProvider$Skilful__$ResponseContainer, {
              onClick: onClick,
              children: React.createElement(SkilfulClozeCommon$LiteracyplanetTupperware.CorrectResponse.make, {
                    children: children
                  })
            });
}

function renderIncorrectDroppedComponent(onClick, children) {
  return React.createElement(SkilfulClozeBucketProvider$Skilful__$ResponseContainer, {
              onClick: onClick,
              children: React.createElement(SkilfulClozeCommon$LiteracyplanetTupperware.IncorrectResponse.make, {
                    children: children
                  })
            });
}

function renderUndroppedMarkedComponent(onClick, children) {
  return children;
}

function renderDragComponent(onClick, children) {
  return children;
}

function SkilfulClozeBucketProvider$Skilful__(props) {
  return React.createElement(V3ClozeBucketProvider$LiteracyplanetTupperware.make, {
              overClassName: overClassName,
              dropClassName: dropClassName,
              renderDragComponent: renderDragComponent,
              renderDragOverlayComponent: renderDragOverlayComponent,
              renderAlreadyDraggedPlaceholder: renderAlreadyDraggedPlaceholder,
              renderAlreadyDraggedAndMarkedPlaceholder: renderAlreadyDraggedAndMarkedPlaceholder,
              renderDroppedComponent: renderDroppedComponent,
              renderCorrectDroppedComponent: renderCorrectDroppedComponent,
              renderIncorrectDroppedComponent: renderIncorrectDroppedComponent,
              renderUndroppedMarkedComponent: renderUndroppedMarkedComponent,
              questionIndex: props.questionIndex,
              reveal: props.reveal,
              children: props.children
            });
}

var Skilful__ = {
  overClassName: overClassName,
  dropClassName: dropClassName,
  ResponseContainer: ResponseContainer,
  DragOverlayContainer: DragOverlayContainer,
  DroppedContainer: DroppedContainer,
  HiddenDrag: HiddenDrag,
  renderDragOverlayComponent: renderDragOverlayComponent,
  renderAlreadyDraggedPlaceholder: renderAlreadyDraggedPlaceholder,
  renderAlreadyDraggedAndMarkedPlaceholder: renderAlreadyDraggedAndMarkedPlaceholder,
  renderDroppedComponent: renderDroppedComponent,
  renderCorrectDroppedComponent: renderCorrectDroppedComponent,
  renderIncorrectDroppedComponent: renderIncorrectDroppedComponent,
  renderUndroppedMarkedComponent: renderUndroppedMarkedComponent,
  renderDragComponent: renderDragComponent,
  make: SkilfulClozeBucketProvider$Skilful__
};

function SkilfulClozeBucketProvider(props) {
  var children = props.children;
  var questionIndex = props.questionIndex;
  FlagsContext$LiteracyplanetClientFlags.use();
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(PilotClozeBucketProvider$LiteracyplanetTupperware.make, {
                questionIndex: questionIndex,
                reveal: "Hide",
                children: children
              });
  } else {
    return React.createElement(SkilfulClozeBucketProvider$Skilful__, {
                questionIndex: questionIndex,
                reveal: "Hide",
                children: children
              });
  }
}

var make = SkilfulClozeBucketProvider;

var $$default = SkilfulClozeBucketProvider;

export {
  Skilful__ ,
  make ,
  $$default as default,
}
/* react Not a pure module */
